import * as React from 'react';
import {
    FormGroup,
    ControlLabel,
    Row,
    Col, FormControl, Button
} from 'react-bootstrap';
import FormSelect from '../../../components/common/FormSelect';
import { Translate } from '../../../shared/LanguageService';
import {useState} from "react";

interface IProps {
    archiveSource: any,
    availableArchiveSources: any[],
    updateArchiveSource: (archiveSource : any) => void,
    onChange: (e: any) => void,
    procountorId: string
    
}

const Integration = (props: IProps) => {
    
    return (
        <fieldset>
            <legend>{Translate('broker/ordersources/form/title')}</legend>
            <Row>
                <Col sm={6}>
                    <FormGroup>
                        <ControlLabel>
                            {Translate('broker/ordersources/form/archivesource')}
                        </ControlLabel>
                        <FormSelect 
                            name="selectedArchiveSourceId"
                            value={
                                props.archiveSource
                                    ? props.archiveSource.value
                                    : 0
                            }
                            onChange={props.updateArchiveSource}
                        >
                            <option value="0" key="0" disabled={true}>
                                    {Translate('broker/ordersources/form/archivesource-default-option')}
                            </option>
                            {props.availableArchiveSources ? props.availableArchiveSources.map((x: any) => (
                                <option value={x.value} key={x.value}>
                                   {Translate(x.displayName)}
                                </option>
                            )) : null}
                        </FormSelect>
                    </FormGroup>
                    <FormGroup>
                        <ControlLabel>
                            {Translate('broker/ordersources/form/ProcountorId')}
                        </ControlLabel>
                        <FormControl 
                            type="text"
                            name="procountorId"
                            maxLength={40}
                            value = {props.procountorId ? props.procountorId : ''}
                            onChange = {props.onChange}
                        >
                        </FormControl>
                    </FormGroup>
                </Col>
            </Row>
        </fieldset>
    );
}

export default Integration;